// extracted by mini-css-extract-plugin
module.exports = {"btnText":"CartAddBtn_btnText__1YxGo","btn":"CartAddBtn_btn__wtnAl","inactive":"CartAddBtn_inactive__2eZge","svgSecondary":"CartAddBtn_svgSecondary__BzepT"};